import { Outlet } from 'react-router-dom';

// Components
// ----
import { Header } from '../../components/header/header';
import { Footer } from '../../components/footer/footer';
//import { Subscription } from '../../components/subscription/subscription';

export const Layout = ({ ...props }) => {
  console.log('PUBLIC_URL is ' + process.env.PUBLIC_URL);
  return (
    <>
      <Header></Header>
      <div className="body-wrapper">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};
//
